import { AuthService } from "src/app/Auth/auth.service";
import { NgForm, FormGroup, FormControl, Validators } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  constructor(private afAuth: AuthService, private r: Router) {}

  validatingForm = new FormGroup({
    email: new FormControl("", Validators.required),
    password: new FormControl("", [
      Validators.required,
      Validators.minLength(5)
    ])
  });

  ShowPassword = false;
  message;
  isLoading = false;

  ngOnInit() {}
  onSubmit(form: any) {
    this.isLoading = true;
    const email = form.value.email;
    const password = form.value.password;
    this.afAuth
      .logIN(email, password)
      .then(data => {
        this.isLoading = false;
        form.reset();
        this.r.navigate(["/"]);
      })
      .catch(err => {
        console.log(err.message);
        this.message = err.message;
        this.isLoading = false;

        this.r.navigate(["login"]);
      });
  }

  toggleEye() {
    this.ShowPassword = !this.ShowPassword;
  }
}
